import apiClient from './client';

export interface Country {
  id: string;
  code: string;
  name: string;
  phoneCode?: string;
  currencyCode?: string;
  isActive: boolean;
}

export interface CreateCountryRequest {
  code: string;
  name: string;
  phoneCode?: string;
  currencyCode?: string;
}

export interface UpdateCountryRequest {
  code?: string;
  name?: string;
  phoneCode?: string;
  currencyCode?: string;
}

export const countriesApi = {
  // Get all countries
  getAll: (onlyActive: boolean = false) => 
    apiClient.get<Country[]>(`/countries?onlyActive=${onlyActive}`),

  // Get single country by ID
  getById: (id: string) => 
    apiClient.get<Country>(`/countries/${id}`),

  // Create new country
  create: (data: CreateCountryRequest) => 
    apiClient.post<Country>('/countries', data),

  // Update country
  update: (id: string, data: UpdateCountryRequest) => 
    apiClient.put<Country>(`/countries/${id}`, data),

  // Change country status
  changeStatus: (id: string, isActive: boolean) => 
    apiClient.patch<Country>(`/countries/${id}/status`, { isActive }),
};
